import { render, staticRenderFns } from "./PMDashboardForm.vue?vue&type=template&id=b32396f6&"
import script from "./PMDashboardForm.vue?vue&type=script&lang=js&"
export * from "./PMDashboardForm.vue?vue&type=script&lang=js&"
import style0 from "./PMDashboardForm.vue?vue&type=style&index=0&id=b32396f6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports